// 配置接口地址
export const api = {
  getDeviceListByPage: '/bms/device/getDeviceListByPageApi.json', // 查询设备列表
  queryLocationList: 'bas/taskcenter/queryLocationList.json', // 查询保卫人员位置信息
  addTaskInfo: '/bas/taskcenter/addTaskInfoApi.json',
  peopleTrackDetails: '/vas/personnelControl/personnelSearching/peopleTrackDetails.json',
  // 查询车辆研判
  searchVehicleTrail: '/vas/vehicleSearching/searchVehicleTrail.json',
  // 查询区域树
  querydeviceByArea: '/vas/bayonet/querydeviceByArea.json',
  batchFileload: '/common/file/batchFileload.json',
  // 查询人脸
  peopleSearch: 'vas/personnelControl/personnelSearching/peopleSearch.json',
  //识别记录列表分页查询
  queryMatchRecordList: '/vas/matchCenter/queryMatchCenterRecordList.json',
  queryRecordList: '/vas/matchCenter/queryMatchRecordList.json',
  //识别记录标记
  markMatchReocrd: '/vas/matchCenter/markMatchReocrd.json',
  //获取标记时访客类型列表
  getVisitorTypeList: '/vas/personnel/queryVisitorTypeList.json',
  // 查询名单组
  queryGroup: '/vas/faceGroup/queryFaceGroupByType.json',
  // 标记记录列表
  queryMarkingList: '/vas/matchCenter/queryMarkMatchRecordList.json',
  //摄像头配置任务记录
  queryControlTaskCamera: '/vas/controltask/queryControlTaskCamera.json'
}